import React, { Component } from 'react'
import Grid from '@material-ui/Core/Grid'
import Divider from '@material-ui/Core/Divider';
import Typography from '@material-ui/core/Typography';

import FlagIcon from '@material-ui/icons/Flag';

import { withStyles } from '@material-ui/styles';

let dividerColor = window.$secondaryColor

const styles = theme => ({
    dividerTitle: {
        overflow:'hidden',
        fontSize:'20pt',
        '&::after': {
           content:'""',
           
      }
    },
    dividerContainer: {
        width:'100%',
        textAlign:'left'
    }
    })

class TextDivider extends Component {
    constructor(props){
        super(props)
    }

    render() {

        const {classes} = this.props

        //this should be a standalone component for icons
        let icon = []
        if(this.props.content.Icon.length){
            if(this.props.content.Icon == "risk"){
                icon = <FlagIcon style={{color:this.props.content.IconColor}} fontsize='small' />
            }
        }
        dividerColor = this.props.content.DividerColor == "secondary" ? window.$secondaryColor : window.$primaryColor
        return(
            <div style={{marginBottom:'25px'}}>
                <Grid container
                    direction="row"
                    justify="left"
                    alignItems="stretch"
                    noWrap
                    spacing={2}>
                    <Grid item class={classes.dividerContainer}>
                        <Typography variant="h4" class={classes.dividerTitle} color="primary" style={{color:window.$primaryColor}}>{icon} {this.props.content.Title} <div style={{display:'inline-block',
           width:'100%',
           height:'0px',
           marginRight:'-100%',
           borderBottom:'4px solid',
           marginBottom:'3px',
           marginLeft:'12px',
           color: dividerColor}}/></Typography>
                        
                    </Grid>
                    <Grid item>
                        <div></div>
                    </Grid>
                    
                </Grid>
            </div> 
        )
    }
}

export default withStyles(styles)(TextDivider);

/* 

                       
{
    "ComponentClass": "VISUAL",
    "ComponentFamily": "DIVIDER",
    "ComponentType": "TEXTDIVIDER",
    "ComponentVisible": "1",
    "ComponentContent": {
      "Title": "Overview",
      "Icon": "",
      "IconColor": "red",
      "DividerColor": "secondary"
    }
  }
*/